import $ from 'jquery';
import 'jquery.dotdotdot';
import 'tooltipster/dist/css/tooltipster.bundle.min.css';
import 'tooltipster';

window.jQuery = $;
window.$ = $;
jQuery.noConflict();

(function ($) {
  $(document).ready(function () {

    /* Sticky Header */
    const header = document.querySelector('.header');
    const headerFixedScrollThreshold = 116;

    if(header) {
      if (window.scrollY >= headerFixedScrollThreshold) {
        header.classList.add('fixed');
      }

      window.addEventListener('scroll', function () {
        if (window.scrollY >= headerFixedScrollThreshold) {
          header.classList.add('fixed');
        } else {
          header.classList.remove('fixed');
        }
      });
    }

    /* Resize event */
    $(window).resize(function () {
      if (this.resizeTo) clearTimeout(this.resizeTo);
      this.resizeTo = setTimeout(() => $(this).trigger('resizeEnd'), 500);
    });

    /* Prevent mailto link default behavior */
    $('a[mailto]').click((e) => e.preventDefault());

    /* Press Releases Filtering */
    $('.PressReleasesChapter .filter .radios > div').click(function () {
      if ($(this).attr('data-value') === 'All') {
        $('.content-container.press-release').removeClass('hidden');
      } else {
        $('.content-container.press-release').addClass('hidden');
        $('.content-container.press-release[data-category="' + $(this).attr('data-value') + '"]').removeClass('hidden');
      }
    });

    /* Radio Buttons */
    $('.radios > div').click(function () {
      $(this).parent().removeClass('error');
      if ($(this).hasClass('active')) return;
      $(this).parent().find('> div').removeClass('active');
      $(this).addClass('active');
      $(this).parent().parent().find('input[type="hidden"]').val($(this).attr('data-value'));
    });

    /* DotDotDot (Text kürzen) */
    if ($(".dotdot.readmore").length) {
      $(".dotdot.readmore").dotdotdot({
        ellipsis: ' ',
        height: 90,
        after: "a.readmore"
      });
    }

    if (document.body.classList.contains('Projects')) {
      import('./projects').then(({ setupProjects }) => {
        setupProjects();
      });
    }

    /* Gallery */
    if ($('.galleryContainer').length) {
      import('./gallery').then(({ setupGallery }) => {
        setupGallery();
      });
    }

    /* Scroll to anchor on page load */
    if (window.location.hash.length) {
      let id = window.location.hash.replace('#', '');
      if ($('.anker[name="' + id + '"]').length) {
        $("html, body").stop().animate({
          scrollTop: ($('.anker[name="' + id + '"]').offset().top)
        }, 500, 'swing');
      }
    }

    /* Navigation */

    /* Navigation Toggle */
    $('#burger').click(function(){
      $('body').toggleClass('navOpen');
      $(this).addClass('mobileNavInited').toggleClass('open');
    });
    $('#closeHelper').click(() => {
      $('body').removeClass('navOpen');
      $('#burger').removeClass('open');
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1010) {
        document.body.classList.remove('navOpen');
        $('#burger').removeClass('mobileNavInited').removeClass('open');
      }
    });

  });
}(jQuery));